import { rem } from 'polished';
import { Box, Flex, Link, Image, Text, Icon } from '@qga/roo-ui/components';
import styled from '@emotion/styled';
import { baggage } from '@qga/roo-ui/assets';
import { useHeaderContext } from '../HeaderContext';
import { themeGet } from 'styled-system';
import type { FC } from 'react';

export interface TooltipProps {
  arrowDirection?: string;
}

export const LoginTooltip: FC<TooltipProps> = ({ arrowDirection }) => {
  const {
    onDismissLoginTooltip = () => {},
    onInteraction,
    qffAuthData,
    onClickLogin,
    displayLoginTooltip,
  } = useHeaderContext();

  const handleDismiss = () => {
    onDismissLoginTooltip();
    onInteraction({ type: 'Login tooltip', value: 'LoginTooltip Dismissed' });
  };
  if (!displayLoginTooltip || qffAuthData.isAuthenticated) return null;

  return (
    <TooltipWrapper
      width={['100%', '100%', '350px']}
      mt={[-3, -3, 0]}
      mr={[0, 0, -3]}
      data-testid="login-tooltip"
      flexDirection={['column', 'column', 'row']}
    >
      {arrowDirection === 'up' && <ArrowUp />}
      <Card
        justifyContent={['space-between', 'space-between', 'center']}
        alignItems="center"
      >
        <Flex justifyContent="center" alignItems="center">
          <Box display="block" width={rem('86px')}>
            <Image
              alt={baggage}
              src={baggage}
              height={rem('46px')}
              width="100%"
              pr={4}
            />
          </Box>
          <Text display="block" fontSize="base">
            <Link
              mr={1}
              underline
              color="inherit"
              role="button"
              onClick={onClickLogin}
              data-testid="login-link"
            >
              Login{' '}
            </Link>
            to access incredible deals for members!
          </Text>
        </Flex>

        <Box>
          <Icon
            name="close"
            ml={8}
            mr={0}
            size={18}
            color="greys.dusty"
            onClick={handleDismiss}
            data-testid="close-icon"
          />
        </Box>
      </Card>
      {arrowDirection === 'right' && <ArrowRight />}
    </TooltipWrapper>
  );
};

const TooltipWrapper = styled(Flex)`
  z-index: ${themeGet('zIndices.stickyNavigation')};
`;

const ArrowUp = styled(Box)`
  z-index: ${themeGet('zIndices.loginToolTip')};
  margin-bottom: -1px;
  align-self: flex-end;
  margin-right: ${themeGet('space.8')};
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid ${themeGet('colors.white')};

  ${themeGet('mediaQueries.1')} {
    border-bottom: 10px solid ${themeGet('colors.snow')};
  }
`;

const ArrowRight = styled(Box)`
  align-self: center;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 10px solid ${themeGet('colors.white')};
`;

const Card = styled(Flex)`
  z-index: ${themeGet('zIndices.stickyCampaignMessaging')};
  height: 74px;
  padding: ${themeGet('space.4')};
  background: linear-gradient(-180deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 35%, #E6E6E6 100%);
  border-top: 1px solid ${themeGet('colors.greys.alto')};
  border-bottom: 1px solid ${themeGet('colors.greys.alto')};
  box-shadow: ${themeGet('shadows.hover')};

  ${themeGet('mediaQueries.1')} {
    border-top: 0px;
    border-radius: 0 0 0 ${themeGet('radii.default')};
  }
}
`;
